<template>
    <transition name="fade">
        <div v-show="isShow" class="selector-roll" @touchstart.prevent="close">
            <div class="selector-main" @touchstart.stop>
                <div class="selector-top">
                    <div>
                        <span class="selector-title">{{ title }}</span>
                        <span class="icon-close" @click.prevent="close"></span>
                    </div>
                </div>
                <div class="selector-content">
                    <div class="selector-tab">
                        <div
                            v-for="item in tabList"
                            :key="item.code"
                            :class="{ active: item.code === selectTabCode }"
                            @click="selectTabEvent(item.code)"
                        >
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                    <div class="selector-search">
                        <input
                            v-model="searchValue"
                            type="text"
                            placeholder="请输入地区名进行搜索"
                            class="input-search"
                            @input="inputChange"
                            @click="searchInputFocus"
                            @blur="searchInputBlur"
                        />
                        <i class="icon-search"></i>
                        <i v-if="searchValue" class="icon-close" @click.prevent="clear"></i>
                    </div>
                    <div class="selector-area">
                        <div v-if="!searchAddressList.length" class="area-title">
                            <div v-for="item in areaLabelText" :key="item">
                                {{ item }}
                            </div>
                        </div>
                        <div v-show="!searchAddressList.length">
                            <area-picker
                                v-show="selectTabCode !== 'ibu'"
                                ref="comAreaPicker"
                                :slots="comAddressSlots"
                                value-key="name"
                                @change="onValuesChange"
                            ></area-picker>
                            <area-picker
                                v-show="selectTabCode === 'ibu'"
                                ref="ibuAreaPicker"
                                :slots="ibuAddressSlots"
                                value-key="name"
                                @change="onValuesChangeIbu"
                            ></area-picker>
                        </div>
                        <ul v-show="searchAddressList.length" class="search-address-region">
                            <li
                                v-for="(item, index) in searchAddressList"
                                :key="index"
                                :class="{ active: index === selectedItemIndex }"
                                @click="selectedSearchAddress(item, index)"
                                v-html="item.html"
                            ></li>
                        </ul>
                    </div>
                </div>
                <div class="selector-bottom">
                    <div class="btn-confirm" :class="{ active: enableBtn }">
                        <span @click="confirm">确认</span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { Picker } from 'mint-ui'
import ajax from '@/api/ajax'
import ibuCountry from '@/constant/ibuCountry'
import { areaTabMap, LabelTabText, regionKey, areaTypeMap } from './config'
import UIP from '@/util/uip.js'
import { getHighHtml } from '@/util/util.js'
import { LOCATION_CODE_MAP, COUNTRY_CODE } from '@uip-alpha/business-constants'

export default {
    name: 'AreaSelector',
    components: {
        areaPicker: Picker
    },
    props: {
        title: {
            type: String,
            default: '区域选择'
        },
        areaTypeList: {
            type: Array,
            default: () => [areaTypeMap.cn, areaTypeMap.hmt, areaTypeMap.ibu]
        },
        isShow: {
            // 是否显示该组件
            type: Boolean,
            default: false
        },
        area: {
            type: Array,
            default: () => []
        },
        tabCode: {
            type: String,
            default: areaTypeMap.cn
        }
    },
    data() {
        return {
            searchValue: '', // 搜索值
            searchAddressList: [], // 搜索结果列表
            selectedItemIndex: -1, // 搜索结果选中索引
            cnList: [], // 大陆的数组
            hmtList: [], // 港澳台的数组
            ibuList: [], // 国际国家的数组
            provinceList: [], // 省的数组
            cityList: [], // 省对应城市的数组
            districtList: [], // 区或者县的数组
            areaLabelText: [], // 展示的区域标签文本
            comAddressSlots: [
                {
                    flex: 1,
                    values: [], // 省份数组
                    className: 'slot1',
                    textAlign: 'center'
                },
                {
                    flex: 1,
                    values: [],
                    className: 'slot2',
                    textAlign: 'center'
                },
                {
                    flex: 1,
                    values: [],
                    className: 'slot3',
                    textAlign: 'center'
                }
            ],
            ibuAddressSlots: [
                {
                    flex: 1,
                    values: [], // 省份数组
                    className: 'slot1',
                    textAlign: 'center'
                }
            ],
            privinceCode: '', // 选中的省或直辖市code
            cityCode: '', // 选中的城市code
            selectArea: [], // 最终选择的省市区
            enableBtn: true, // 确认按钮是否可用
            selectTabCode: this.tabCode || areaTabMap.cn, // tab区域码
            tabList: areaTabMap, // 需要展示选择的tablist
            ibuAreaPicker: 'ibuAreaPicker', // 国际选择的picker
            comAreaPicker: 'comAreaPicker', // 普通省市区的picker
            cnLabelText: LabelTabText.get(areaTypeMap.cn), // 大陆区域选择器标签tab
            hmtLabelText: LabelTabText.get(areaTypeMap.hmt), // 港澳台区域选择器标签tab
            ibuLabelText: LabelTabText.get(areaTypeMap.ibu), // 国际区域选择器标签tab
            areaCopy: []
        }
    },
    watch: {
        async areaTypeList(val, old) {
            this.updateTypeList()
        },
        searchValue(val) {
            if (!val) {
                this.clear()
            }
            this.selectTabEvent(this.selectTabCode)
        },
        selectedItemIndex(val) {
            if (this.searchAddressList.length > 0 && val < 0) {
                this.enableBtn = false
            } else {
                this.enableBtn = true
            }
        },
        searchAddressList: {
            handler(val) {
                if (val.length > 0 && this.selectedItemIndex < 0) {
                    this.enableBtn = false
                } else {
                    this.enableBtn = true
                }
            },
            deep: true,
            immediate: true
        },
        async isShow(val) {
            this.updateTypeList()
            if (val && JSON.stringify(this.area) !== JSON.stringify(this.selectArea.filter(item => Boolean(item)))) {
                this.selectTabCode = this.tabCode || areaTypeMap.cn
                await this.selectTabEvent(this.selectTabCode)
                setTimeout(() => {
                    this.areaCopy = [...this.area]
                    if (this.areaCopy[0]) {
                        const targetIndex = this.provinceList.findIndex(item => item.name === this.areaCopy[0].name)
                        if (this.selectTabCode === areaTypeMap.ibu) {
                            this.$refs[this.ibuAreaPicker] && this.$refs[this.ibuAreaPicker].setSlotValue(0, this.provinceList[targetIndex])
                        } else {
                            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(0, this.provinceList[1])
                            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(0, this.provinceList[targetIndex])
                        }
                        this.areaCopy[0] = null
                    }
                }, 500)
            }
        }
    },
    async created() {
        // 过滤需要展示的地址选择类型
        this.cnList = await this.getRegion(COUNTRY_CODE.MAINLAND, 1)
        this.getHmtIbuList()
        this.selectTabEvent(this.tabList[0].code)
    },
    mounted() {
        // this.$nextTick(() => {
        // 	//vue里面全部加载好了再执行的函数 （类似于setTimeout）
        //     this.comAddressSlots[0].defaultIndex = 0;
        // });
        window.addEventListener('resize', this.resizeHeight, false)
    },
    beforeDestroy() {
        // 销毁前解绑
        window.removeEventListener('resize', this.resizeHeight, false)
    },
    methods: {
        updateTypeList() {
            this.tabList = areaTabMap
            // 过滤需要展示的地址选择类型
            this.tabList = this.tabList.filter(item => this.areaTypeList.indexOf(item.code) > -1)
            this.selectTabEvent(this.tabList[0].code)
        },
        // 模糊搜索
        async inputChange() {
            if (this.searchValue) {
                const options = {
                    regionKey: regionKey.get(this.selectTabCode) || 'local_region_cn_sc',
                    count: '1000'
                }
                // this.searchAddressList1 = await this.$I.region.search(this.searchValue, options)
                if (this.selectTabCode === 'ibu') {
                    this.searchAddressList = this.ibuList.filter(item => item.name === this.searchValue)
                    this.searchAddressList.forEach(item => {
                        item.html = getHighHtml(item.name, this.searchValue)
                    })
                } else {
                    this.searchAddressList = await UIP.interface.region.search(this.searchValue, options)
                    this.searchAddressList.forEach(item => {
                        const str = [item.province, item.city, item.county].filter(item => !!item).join('-')
                        item.html = getHighHtml(str, this.searchValue)
                    })
                }
            }
        },
        // 点击输入框时处理安卓 键盘挡住问题
        searchInputFocus() {
            const timerFocus = setTimeout(() => {
                timerFocus && clearTimeout(timerFocus)
                document.body.scrollTop = 0
                // 如果document.body.scrollTop始终为0，用document.documentElement.scrollTop代替
                document.documentElement.scrollTop = 0
                window.scrollTo && scrollTo(0, 0)
            }, 500)
        },
        // 输入框失去焦点
        searchInputBlur() {
            const timerBlur = setTimeout(() => {
                timerBlur && clearTimeout(timerBlur)
            }, 500)
        },
        // 选择搜索结果中的某一条
        selectedSearchAddress(item, index) {
            const tempResult = []
            if (this.selectTabCode === areaTypeMap.ibu) {
                tempResult.push(item)
            } else {
                tempResult.push({ code: item.provinceAreaCode, rateCode: item.provinceLocationCode, name: item.province })
                tempResult.push({ code: item.cityAreaCode, rateCode: item.cityLocationCode, name: item.city })
                tempResult.push({ code: item.countyAreaCode, rateCode: item.countyLocationCode, name: item.county })
            }
            this.selectArea = tempResult
            this.selectedItemIndex = index
        },
        clear() {
            this.selectedItemIndex = -1
            this.searchAddressList = []
            this.searchValue = ''
        },
        // 切换大陆、港澳台、国际
        async selectTabEvent(code) {
            // this.clear()
            if (this.selectTabCode !== code) {
                this.clearPicker()
                this.clear()
            }
            this.selectTabCode = code
            this.selectedItemIndex = -1
            if (this.selectTabCode === areaTypeMap.cn) {
                await this.handleAreaData(this.cnList)
                this.areaLabelText = this.cnLabelText
            } else if (this.selectTabCode === areaTypeMap.hmt) {
                await this.handleAreaData(this.hmtList)
                this.areaLabelText = this.hmtLabelText
            } else if (this.selectTabCode === areaTypeMap.ibu) {
                this.provinceList = this.ibuList
                this.selectArea = [this.provinceList[0]]
                this.privinceCode = this.provinceList[0].code
                this.$refs[this.ibuAreaPicker] && this.$refs[this.ibuAreaPicker].setSlotValues(0, this.provinceList)
                this.$refs[this.ibuAreaPicker] && this.$refs[this.ibuAreaPicker].setSlotValue(0, this.provinceList[0])
                this.areaLabelText = this.ibuLabelText
                // this.searchAddressList = []
            }
            // 大陆和港澳台通过uip查询，国际直接从已有数据中筛选
            if (this.searchValue && this.selectTabCode !== areaTypeMap.ibu) {
                this.inputChange()
            }
        },
        // 关闭选择器
        close() {
            this.clear()

            this.$emit('closeAreaSelector')
        },
        // 确认选择
        async confirm() {
            if (!this.enableBtn) {
                return
            }
            this.$emit('confirm', {
                selectArea: this.selectArea.filter(item => Boolean(item)),
                selectTabCode: this.selectTabCode
            })
            this.close()
        },
        // 调接口获取某区域下所有区域
        async getRegion(code, level) {
            const { data } = await ajax.getRegions({
                lang: 'sc',
                regiion: 'cn',
                translate: 'sc',
                params:
                    this.selectTabCode === areaTypeMap.cn
                        ? {}
                        : {
                              level
                          },
                data: {
                    code
                }
            })
            return data
        },
        // 选择器picker发生值变化
        onValuesChange(picker, values) {
            // 省市都有数据时才需要调接口实现联动
            if (!this.selectTabCode) {
                return
            }
            if (this.selectTabCode === areaTypeMap.cn && (!values[0] || !values[1])) {
                return
            }
            if (this.selectTabCode === areaTypeMap.hmt && (!values[0] || !values[1])) {
                return
            }
            this.selectArea = values
            const privinceCode = values[0] && values[0].code
            if ((privinceCode !== this.privinceCode && this.selectTabCode !== areaTypeMap.ibu) || this.areaCopy[1]) {
                this.getRegionList(privinceCode, 1)
                this.privinceCode = privinceCode
            }
            const cityCode = values[1] && values[1].code
            if ((cityCode !== this.cityCode && this.selectTabCode !== areaTypeMap.ibu) || (!this.areaCopy[1] && this.areaCopy[2])) {
                this.getRegionList(cityCode, 2)
                this.cityCode = cityCode
            }
        },
        // 国际切换国家
        onValuesChangeIbu(picker, values) {
            if (this.selectTabCode === areaTypeMap.ibu && !values[0]) {
                return
            }
            this.selectArea = values
        },
        // 初始化省市区数据
        async handleAreaData(initList) {
            this.provinceList = initList
            this.cityList = await this.getRegion(this.provinceList[0].code, 2)
            this.districtList = await this.getRegion(this.cityList[0].code, 3)
            this.privinceCode = this.provinceList[0].code
            this.cityCode = this.cityList[0].code
            this.selectArea = [{ ...this.provinceList[0] }, { ...this.cityList[0] }, { ...this.districtList[0] }]
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(0, this.provinceList)
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(0, this.provinceList[0])
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(1, this.cityList)
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(1, this.cityList[0])
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(2, this.districtList)
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(2, this.districtList[0])
        },
        // 获取省市区数据
        async getRegionList(code, tab) {
            switch (tab) {
                // case 0:
                //     this.handleAreaData(await this.getRegion(code))
                //     break;
                case 1:
                    // 选择省，重新获取市区
                    this.cityList = await this.getRegion(code, 2)
                    if (this.areaCopy[1]) {
                        const targetIndex = this.cityList.findIndex(item => item.name === this.areaCopy[1].name)
                        this.districtList = (this.cityList[targetIndex] && (await this.getRegion(this.cityList[targetIndex].code, 3))) || []
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(1, this.cityList)
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(1, this.cityList[targetIndex])
                        this.areaCopy[1] = null
                    } else {
                        this.districtList = (await this.getRegion(this.cityList[0].code, 3)) || []
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(1, this.cityList)
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(1, this.cityList[0])
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(2, this.districtList)
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(2, this.districtList[0])
                    }
                    break
                case 2:
                    // 选择了市，重新获取区
                    this.districtList = await this.getRegion(code, 3)
                    this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(2, this.districtList)
                    if (this.areaCopy[2]) {
                        const targetIndex = this.districtList.findIndex(item => item.name === this.areaCopy[2].name)
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(2, this.districtList[targetIndex])
                        this.areaCopy[2] = null
                    } else {
                        this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValue(2, this.districtList[0])
                    }
                    break
                default:
                    break
            }
        },
        // 获取港澳台和国际数据
        async getHmtIbuList() {
            const resultList = await this.getRegion('A000000000', 1)
            const tempList = []
            ibuCountry.countryList.map(item => tempList.push(item.code))
            const filterHmtIbuList = resultList.filter(item => tempList.includes(item.rateCode))
            const HKMOTWCodeList = [LOCATION_CODE_MAP.HK, LOCATION_CODE_MAP.MAC, LOCATION_CODE_MAP.TW]
            this.hmtList = filterHmtIbuList.filter(item => HKMOTWCodeList.includes(item.rateCode))
            this.ibuList = filterHmtIbuList.filter(item => !HKMOTWCodeList.includes(item.rateCode))
        },
        clearPicker() {
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(0, [])
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(1, [])
            this.$refs[this.comAreaPicker] && this.$refs[this.comAreaPicker].setSlotValues(2, [])
            this.$refs[this.ibuAreaPicker] && this.$refs[this.ibuAreaPicker].setSlotValue(0, [])
        }
    }
}
</script>

<style lang="scss" scoped>
.selector-roll {
    position: absolute;
    z-index: 999;
    width: 100%;
    top: 0;
    bottom: 0;
    max-width: 7.5rem;
    color: #000;
    background: rgba(0, 0, 0, 0.5);
    .selector-main {
        position: absolute;
        bottom: 0;
        width: 100%;
        min-height: 5rem;
        display: flex;
        flex-flow: column nowrap;
        background: #fff;
        border-radius: 0.08rem 0.08rem 0 0;
        .selector-top {
            position: relative;
            text-indent: 1ch;
            font-size: 0.3rem;
            color: #111111;
            font-weight: 800;
            padding: 0.34rem 0.1rem;
            border-bottom: 0.04rem solid #f8f9fa;
            div {
                position: relative;
                .icon-close {
                    position: absolute;
                    top: -0.05rem;
                    right: 0.2rem;
                    width: 0.5rem;
                    height: 0.5rem;
                    &:before {
                        position: absolute;
                        top: 50%;
                        content: '';
                        display: block;
                        height: 5px;
                        width: 0.36rem;
                        background: #000;
                        transform: rotate(45deg);
                    }
                    &:after {
                        position: absolute;
                        top: 50%;
                        content: '';
                        display: block;
                        height: 5px;
                        width: 0.36rem;
                        background: #000;
                        transform: rotate(-45deg);
                    }
                }
            }
        }
        .selector-content {
            padding: 0.2rem 0.3rem 0;
            .selector-tab {
                display: flex;
                justify-content: center;
                flex-wrap: nowrap;
                div {
                    margin: 0 0.26rem;
                }
                > div {
                    width: 25%;
                    padding: 0.05rem 0.1rem;
                    border-radius: 0.3rem;
                    font-size: 0.26rem;
                    border: 1px solid #e4e4e4;
                    text-align: center;
                    &.active {
                        border-color: #dc1e32;
                        color: #dc1e32;
                    }
                }
            }
            .selector-search {
                position: relative;
                margin: 0.3rem 0.3rem 0;
                width: calc(100% - 0.6rem);
                height: 0.64rem;
                z-index: 9;
                .input-search {
                    position: relative;
                    padding: 0 0.7rem 0 0.57rem;
                    border: none;
                    font-size: 0.26rem;
                    color: #333;
                    background-color: #f2f2f2;
                    border-radius: 0.32rem;
                    line-height: 0.64rem;
                }
                .icon-search {
                    position: absolute;
                    display: inline-block;
                    z-index: 9;
                    left: 0.2rem;
                    top: 0.18rem;
                    width: 0.32rem;
                    height: 0.32rem;
                    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEUAAAD09PTNzc3Nzc3Ozs7Nzc3Nzc3Nzc3Ozs7Nzc3Nzc3Nzc3Nzc3MzMzOzs7Nzc3Ozs7MzMzNzc3Nzc3MzMzNzc3Nzc3Nzc3Ozs7Q0NDb29vMzMzNzc3Nzc3Nzc3MzMzMzMzNzc3Ozs7Pz8/Pz8/Pz8/S0tLW1tbMzMzNzc3Pz8/Pz8/MzMxPXryiAAAALHRSTlMAAvr1H+a9nXbrzMSVkoBmQNvUh4N6bWBXGwny4baqjHNPOTIqJRYSr4lKEMCbKhoAAADuSURBVDjLvZLHcoMwAAVVANMNmOru2E7d//++ZEhiSwpDbt7b8vagQRKPpMiqSG2D9nl6Pif8oOv1xL5U4xYBEA9/d2ATekLIYgeUL87+pCDwfuPNlzhBAoG858DJPj9oz/ADxFaQQWj62gfP/FA5LlLoTI/QwqKFxnSFbwcdrEzfoqQVhHA0PYDCCnbwbvoR9qZfFMq6D09Bf1cZQybcHxFdbvsBtHPnHyWo8Pug1wRIpLC5+kBV96flXgOwcIsh5oZ+nSpkVzKiFoNojMLg3L6leT++ldwtXMYinS1qIBVzrID8v8IXszR+KB7CJ4RTHQJtL2NoAAAAAElFTkSuQmCC)
                        no-repeat;
                    background-size: cover;
                }
                .icon-close {
                    position: absolute;
                    display: inline-block;
                    right: 0.3rem;
                    z-index: 9;
                    top: 0.18rem;
                    width: 0.3rem;
                    height: 0.3rem;
                    width: 0.5rem;
                    background-image: url('~@/assets/images/recStandard/icon-close.png');
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: 0.28rem;
                }
            }
            .selector-area {
                position: relative;
                height: 4rem;
                .area-title {
                    display: flex;
                    position: relative;
                    justify-content: center;
                    background: #fff;
                    align-items: center;
                    height: 1rem;
                    z-index: 9;
                    div {
                        width: 33.3%;
                        text-align: center;
                        font-size: 30px;
                        color: #333333;
                    }
                }
                >>> .picker {
                    position: relative;
                    left: 0;
                    top: -1.02rem;
                    width: 100%;
                    z-index: 1;
                }
                >>> .picker-item {
                    color: #707274;
                    &.picker-selected {
                        color: #dc1e32;
                    }
                }
                .search-address-region {
                    padding-top: 0.32rem;
                    max-height: 7rem;
                    overflow-y: scroll;
                    li {
                        width: 100%;
                        min-height: 0.96rem;
                        line-height: 0.96rem;
                        padding: 0.26rem 0.44rem;
                        font-size: 0.3rem;
                        line-height: 0.42rem;
                        >>> i {
                            color: rgba(226, 12, 12, 0.842);
                            font-style: normal;
                        }
                        &:nth-child(odd) {
                            background-color: #f9f9f9;
                        }
                        &.active {
                            color: rgba(226, 12, 12, 0.842);
                            &::before {
                                content: '\2714';
                                position: relative;
                                float: right;
                            }
                        }
                    }
                }
            }
        }
        .selector-bottom {
            z-index: 99;
            background: #fff;
            .btn-confirm {
                padding: 0.2rem.5rem;
                >>> span {
                    display: inline-block;
                    width: 100%;
                    border-radius: 0.48rem;
                    text-align: center;
                    color: #fff;
                    font: bold 0.34rem/3 YaHei;
                    letter-spacing: 0.5rem;
                    text-indent: 0.5rem;
                    background: rgba(0, 0, 0, 0.3);
                }
                &.active {
                    >>> span {
                        background: #dc1e32;
                        color: #ffffff;
                    }
                }
            }
        }
    }
}

::-webkit-scrollbar {
    display: none;
}
.fade-enter-active,
.fade-leave-active {
    bottom: 0;
    opacity: 1;
    transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    bottom: -100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/areaSelector/index.vue